import { Directive, ElementRef, HostListener, inject } from '@angular/core';

/**
 * Selects (highlights) an input's current value when it receives focus, so the
 * next keystroke overwrites it instead of appending. Mirrors the design
 * mockup's `onfocus="this.select()"` behaviour on the account-request forms.
 *
 * Standalone so it can be imported directly by standalone components.
 */
@Directive({
  selector: '[appSelectOnFocus]',
  standalone: true,
})
export class SelectOnFocusDirective {
  private readonly el = inject<ElementRef<HTMLInputElement>>(ElementRef);

  @HostListener('focus')
  onFocus(): void {
    const input = this.el.nativeElement;
    // Defer to the next tick so that a mouse click's own caret placement
    // (which happens after focus) doesn't immediately clear the selection.
    setTimeout(() => input.select());
  }
}
